module.exports = __webpack_public_path__ + "img/apple-logo-mini.cdf835bb.svg";